import { useState } from "react";
import {
  populationSelect,
  pibSelect,
  pibPerCapitaSelect,
  faixaRendaSelect,
} from "../../../../config/data";
import SelectEstados from "../../../form/SelectEstados";
import SelectMunicipios from "../../../form/SelectMunicipios";
import SelectBasic from "../../../form/SelectBasic";
import { Col, Row } from "antd";
import { usePostHog } from "posthog-js/react";

// CEP and District was commented, because they will doesn't have free information by API

export default function LocalityFilter({ onChange, aiGeneration = false }: any) {
  const [selectedUF, setSelectedUF] = useState<string[]>([]);
  const [selectedMun, setSelectedMun] = useState<string[]>([]);
  // const [district, setDistrict] = useState<string>("");
  // const [cep, setCep] = useState<string>("");
  const [population, setPopulation] = useState<number>();
  const [pib, setPib] = useState<number>();
  const [pibPerCapita, setPibPerCapita] = useState<number>();
  const [faixaRenda, setFaixaRenda] = useState<string | string[]>([]); // adicionado
  const posthog = usePostHog();

  const handleChange = (field: string, value: string[] | string) => {
    onChange(field, value);
  };

  return (
    <div className="lead-genenation-filter-wrapper">
      <Row gutter={[16, 16]} style={{display:'flex', justifyContent: 'space-between'}}>
        <Col span={aiGeneration ? 8 : 7}>
          <SelectEstados
            size="middle"
            handler={(value) => {
              posthog.capture('selecionar_uf_select');
              setSelectedUF(value);
              handleChange("uf", value);
            }}
        />
        </Col>
        <Col span={aiGeneration ? 8 :  7}>  
          <SelectMunicipios
            size="middle"
            isRequired={false}
            parentValues={selectedUF}
            handler={(value) => {
              posthog.capture('selecionar_municipio_select');
              setSelectedMun(value);
              handleChange("municipio", value);
            }}
          />
        </Col>
        <Col span={7} style={{display: aiGeneration ? 'none': 'inherit'}}>
          <SelectBasic
            mode="multiple"
            name="faixaRenda"
            label="Faixa de renda mensal"
            options={faixaRendaSelect}
            value={faixaRenda}
            onChange={(value) => {
              posthog.capture('selecionar_faixa_renda_select');
              setFaixaRenda(value);
              handleChange("faixaRenda", value);
            }}
          />
        </Col>
      </Row>

      <Row style={{display:'flex', alignItems:'flex-end', justifyContent:'space-between'}} className="mt-4" gutter={[16, 16]}>
        <Col span={7}  style={{display: aiGeneration ? 'none': 'inherit'}}>  
          <SelectBasic
            mode="multiple"
            name="pibPerCapita"
            label="PIB per Capita"
            options={pibPerCapitaSelect}
            value={pibPerCapita}
            onChange={(value) => {
              posthog.capture('selecionar_pib_per_capita_select');
              const unknownValue: unknown = value as unknown;
              const numberValue: number = unknownValue as number;
              setPibPerCapita(numberValue);
              handleChange("pibPerCapita", value);
            }}
          />
        </Col>
        <Col span={7}  style={{display: aiGeneration ? 'none': 'inherit'}}>  
          <SelectBasic
            mode="multiple"
            name="population"
            label="População Municipio"
            options={populationSelect}
            value={population}
            onChange={(value) => {
              posthog.capture('selecionar_populacao_select');
              const unknownValue: unknown = value as unknown;
              const numberValue: number = unknownValue as number;
              setPopulation(numberValue);
              handleChange("population", value);
            }}
          />
      </Col>
        <Col span={7}  style={{display: aiGeneration ? 'none': 'inherit'}}>  
          <SelectBasic
            mode="multiple"
            name="pib"
            label="PIB Municipio"
            options={pibSelect}
            value={pib}
            onChange={(value) => {
              posthog.capture('selecionar_pib_select');
              const unknownValue: unknown = value as unknown;
              const numberValue: number = unknownValue as number;
              setPib(numberValue);
              handleChange("pib", value);
            }}
          />
        </Col>
      </Row>
      <span  style={{display: aiGeneration ? 'none': 'inherit'}} className="lead-genenation-filter-wrapper-footer">Não é necessário preencher todos os campos ou filtros</span>
    </div>
  );
}
